<template>
  <modal name="modal-publish-policy"
        transition="nice-modal-fade"
        :min-width="200"
        :min-height="200"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        width="540"
        height="auto"
        @before-open="beforeOpen"
        @before-close="beforeClose">

    <div class="modal_wrapper policy_modal">
      <div slot="top-right">
        <button @click="$modal.hide('modal-publish-policy')" class="ngdialog-close"></button>
      </div>

      <template v-if="mode === 'accept'">
        <h4 class="c_primary mb10">{{ $t('policy.title') }}</h4>
        <p>{{ $t('policy.intro') }}</p>
        <ul class="policy_list">
          <li v-for="n in 7" :key="n">{{ $t('policy.r' + n) }}</li>
        </ul>
        <label class="policy_check">
          <input type="checkbox" v-model="accepted">
          <span>{{ $t('policy.accept_check') }}</span>
        </label>
        <div class="text-right mt20">
          <button class="btn btn-default btn-initial mr5" @click="cancel">{{ $t('policy.btn_cancel') }}</button>
          <button class="btn btn-primary btn-initial" :disabled="!accepted" @click="accept">{{ $t('policy.btn_accept') }}</button>
        </div>
      </template>

      <template v-else>
        <h4 class="c_primary mb10">{{ $t('policy.blocked_title') }}</h4>
        <p>{{ $t('policy.blocked_intro') }}</p>
        <ul class="policy_list">
          <li v-for="(v, i) in violations" :key="i">{{ messageFor(v) }}</li>
        </ul>
        <div class="text-right mt20">
          <button class="btn btn-primary btn-initial" @click="cancel">{{ $t('policy.btn_ok') }}</button>
        </div>
      </template>
    </div>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      mode: 'accept',
      violations: [],
      accepted: false,
      onResult: null,
      resolved: false,
    }
  },
  methods: {
    beforeOpen(event) {
      const p = (event && event.params) || {}
      this.mode = p.mode || 'accept'
      this.violations = p.violations || []
      this.onResult = typeof p.onResult === 'function' ? p.onResult : null
      this.accepted = false
      this.resolved = false
    },
    finish(ok) {
      if (this.resolved) return
      this.resolved = true
      if (this.onResult) this.onResult(ok)
    },
    accept() {
      this.finish(true)
      this.$modal.hide('modal-publish-policy')
    },
    cancel() {
      this.$modal.hide('modal-publish-policy')
    },
    beforeClose() {
      this.finish(false)
    },
    messageFor(v) {
      const key = 'policy.v.' + v.code
      return this.$te(key)
        ? this.$t(key, { detail: v.detail || '' })
        : this.$t('policy.generic')
    },
  },
}
</script>

<style>
.policy_modal {
  padding: 20px;
  background-color: #ededed;
  border-radius: 5px;
  font-size: 14px;
}
.policy_list {
  margin: 10px 0 15px 18px;
  padding: 0;
}
.policy_list li {
  margin-bottom: 8px;
  line-height: 1.4;
}
.policy_check {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  cursor: pointer;
}
</style>
